import React from "react";
import { t } from "ttag";

import { useActions, useAppDispatch } from "../../reducers";
import { Actions } from "../actions";
import { ICustomerSummary } from "../models.interfaces";
import { CustomerDetails } from "./CustomerDetails";
import { FormView } from "./abstract/FormView";

const generateRandomString = (len: number) => {
    const s = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array(len)
        .join()
        .split(",")
        .map(() => {
            return s.charAt(Math.floor(Math.random() * s.length));
        })
        .join("");
};

export const CustomerCreate = (): React.ReactNode => {
    const dispatch = useAppDispatch();
    const actions = useActions(Actions, dispatch);
    return (
        <FormView
            baseURL={"/api/csr/users/"}
            actions={actions}
            fields={[
                {
                    label: t`Username`,
                    name: "username",
                    type: "text",
                    isRequired: true,
                },
                {
                    label: t`First Name`,
                    name: "first_name",
                    type: "text",
                },
                {
                    label: t`Last Name`,
                    name: "last_name",
                    type: "text",
                },
                {
                    label: t`Email Address`,
                    name: "email",
                    type: "text",
                },
            ]}
            initialValues={{
                username: generateRandomString(30),
            }}
            onPostSave={async (customer: ICustomerSummary) => {
                const component = <CustomerDetails url={customer.url} />;
                actions.pushViewStack(t`Customer Details`, component);
            }}
        />
    );
};
